import { Ab } from '@df/module-ab/ab.namespace';
import { ICmsContentService } from '@icms/core/content/icms-content.service';
import { NICmsContentField } from '@icms/core/content';

ICmsContentService.registerConfig({
    id: Ab.configId,
    name: 'AB Experiments config',
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'experiments',
            title: 'Experiments',
            itemName: 'experiment',
            itemNameField: 'name',
            defaultSize: 1,
            fields: [
                <NICmsContentField.IChoiceField<Ab.TEngine>>{
                    key: 'engine',
                    type: NICmsContentField.EFieldType.choice,
                    title: 'Engine',
                    options: [
                        { key: 'google', title: 'Google Optimize' },
                        { key: 'convertcom', title: 'Convert' },
                        { key: 'adobetarget', title: 'Adobe Target' }
                    ]
                },
                {
                    key: 'name',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Experiment name used in rules',
                    description:
                        'Human readable experiment name used in code or in rules to identify which experiment we are setting condition for',
                    required: true
                },
                {
                    key: 'key',
                    type: NICmsContentField.EFieldType.text,
                    title: 'Experiment key',
                    description: 'Experiment key obtained from the testing tool'
                },
                <NICmsContentField.IToggleField>{
                    key: 'backend',
                    type: NICmsContentField.EFieldType.toggle,
                    title: 'Enable backend'
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'adobetarget_parameters',
                    title: 'Parameters',
                    itemName: 'parameter',
                    defaultSize: 0,
                    canShow: data => data?.engine === 'adobetarget',
                    fields: [
                        {
                            type: NICmsContentField.EFieldType.text,
                            key: 'parameter_name',
                            title: 'Parameter Name',
                            required: true
                        },
                        {
                            type: NICmsContentField.EFieldType.text,
                            key: 'parameter_value',
                            title: 'Parameter Value',
                            required: true
                        }
                    ]
                },
                <NICmsContentField.IRepeaterField>{
                    type: NICmsContentField.EFieldType.repeater,
                    key: 'adobetarget_variants',
                    canShow: data => data?.engine === 'adobetarget',
                    title: 'Variants',
                    itemName: 'Variant',
                    defaultSize: 2,
                    fields: [
                        {
                            type: NICmsContentField.EFieldType.text,
                            key: 'variant_name',
                            title: 'Variant Name',
                            required: true
                        }
                    ]
                }
            ]
        }
    ]
});
